import loadable from "@loadable/component";

export const MainTab = loadable(() => import("./main-tab"), {
  resolveComponent: ({ MainTab }) => MainTab,
});

export const MarketingData = loadable(() => import("./marketing-data"), {
  resolveComponent: ({ MarketingData }) => MarketingData,
});
